import { render, staticRenderFns } from "./dspActionCheckbox.vue?vue&type=template&id=830c28fe&scoped=true"
import script from "./dspActionCheckbox.vue?vue&type=script&lang=js"
export * from "./dspActionCheckbox.vue?vue&type=script&lang=js"
import style0 from "./dspActionCheckbox.vue?vue&type=style&index=0&id=830c28fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "830c28fe",
  null
  
)

export default component.exports